<div id="chart-price-data" style="min-height: 500px;"></div>